import { getLocaleCookie } from '@/app/context/locale/localeCookie';

export function formatDate(ms: number | string | Date | undefined, format: string = 'YYYY/MM/DD'): string {
  if (!ms && ms !== 0) return '';
  const yearMonthMatch = typeof ms === 'string' ? /^(\d{4})-(\d{1,2})$/.exec(ms) : null;
  const date = yearMonthMatch ? new Date(Number(yearMonthMatch[1]), Number(yearMonthMatch[2]) - 1, 1) : new Date(ms);
  if (isNaN(date.getTime())) {
    return '';
  }

  if (format.toUpperCase() === 'ISO') {
    return date.toISOString();
  }
  const HH = String(date.getHours()).padStart(2, '0');
  const mm = String(date.getMinutes()).padStart(2, '0');
  const ss = String(date.getSeconds()).padStart(2, '0');

  if (getLocaleCookie() === 'ja') {
    const isMonthYearOnly = format.includes('YYYY') && /MMMM|MMM|MM/.test(format) && !format.includes('DD');
    let result = isMonthYearOnly
      ? `${date.getFullYear()}年${date.getMonth() + 1}月`
      : `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
    const hasHH = format.includes('HH');
    const hasMM = format.includes('mm');
    const hasSS = format.includes('ss');

    if (hasHH || hasMM || hasSS) {
      const parts: string[] = [];
      if (hasHH) parts.push(`${HH}時`);
      if (hasMM) parts.push(`${mm}分`);
      if (hasSS) parts.push(`${ss}秒`);
      result += ` ${parts.join('')}`;
    }

    return result;
  }

  const map: Record<string, string | number> = {
    YYYY: date.getFullYear(),
    MMMM: date.toLocaleString('en-US', { month: 'long' }),
    MMM: date.toLocaleString('en-US', { month: 'short' }),
    MM: String(date.getMonth() + 1).padStart(2, '0'),
    DD: String(date.getDate()).padStart(2, '0'),
    HH,
    mm,
    ss,
  };

  return format.replace(/YYYY|MMMM|MMM|MM|DD|HH|mm|ss/g, (token) => String(map[token]));
}
